import React from "react";

interface SignInGateNetworkProps {
  /** Describes the whole picture; the tiles themselves are decorative. */
  label: string;
  logoSrc: string;
}

/**
 * Sources feeding one board. Laid out at a fixed width so the connector lines
 * land on the tiles — the block scales as a whole rather than reflowing.
 */
const SOURCES = [
  { name: "Outlook", icon: "O365outlookmail" },
  { name: "Planner", icon: "microsoftplanner" },
  { name: "Jira", icon: "jira" },
  { name: "Trello", icon: "trello" },
  { name: "GitHub", icon: "github" },
] as const;

const TILE_PITCH = 70;
const NETWORK_WIDTH = SOURCES.length * TILE_PITCH;
const CENTRE = NETWORK_WIDTH / 2;
const LINE_HEIGHT = 34;

const SignInGateNetwork: React.FC<SignInGateNetworkProps> = ({
  label,
  logoSrc,
}) => (
  <div
    className="sign-in-gate__network"
    role="img"
    aria-label={label}
    style={{ width: NETWORK_WIDTH }}
  >
    <div className="sign-in-gate__network-row">
      {SOURCES.map((source) => (
        <div className="sign-in-gate__network-item" key={source.name}>
          <span className="sign-in-gate__network-tile">
            <img
              src={`/assets/img/sourceicons/${source.icon}.png`}
              alt=""
              aria-hidden="true"
            />
          </span>
          <span className="sign-in-gate__network-label">{source.name}</span>
        </div>
      ))}
    </div>

    <svg
      className="sign-in-gate__network-lines"
      width={NETWORK_WIDTH}
      height={LINE_HEIGHT}
      viewBox={`0 0 ${NETWORK_WIDTH} ${LINE_HEIGHT}`}
      aria-hidden="true"
      focusable="false"
    >
      {SOURCES.map((source, index) => {
        const from = index * TILE_PITCH + TILE_PITCH / 2;
        return (
          <path
            key={source.name}
            className="sign-in-gate__flow-line"
            d={`M ${from} 0 C ${from} ${LINE_HEIGHT * 0.6}, ${CENTRE} ${LINE_HEIGHT * 0.45}, ${CENTRE} ${LINE_HEIGHT}`}
          />
        );
      })}
    </svg>

    <span className="sign-in-gate__network-tile sign-in-gate__network-tile--hub">
      <img src={logoSrc} alt="" aria-hidden="true" />
    </span>
  </div>
);

export default SignInGateNetwork;
